import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { FormHelperText, InputLabel, TextField } from '@material-ui/core';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { InputProps } from './types';

interface DateEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
  id: string;
  helperText?: string;
}

// Calendar date stored as YYYY-MM-DD (the browser's date input format), no time or zone.
function DateEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  id,
  disabled,
  helperText,
}: DateEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel htmlFor={id} error={Boolean(fieldState.error)}>
            {label}
          </InputLabel>
          <div>
            <TextField
              id={id}
              type="date"
              value={field.value || ''}
              onChange={field.onChange}
              disabled={disabled}
              error={Boolean(fieldState.error)}
            />
            {(fieldState.error?.message || helperText) && (
              <FormHelperText error={Boolean(fieldState.error)}>{fieldState.error?.message || helperText}</FormHelperText>
            )}
          </div>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default DateEditor;
